;
define("merchandising_zone.tpl", function(){});

